// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"4a0b6729","250":"785e3e4f","407":"33e717ce","546":"258dde65","559":"6fc74eb8","673":"e8e58b91","767":"d28cf753"}[chunkId] + ".chunk.js";
};